import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './i18n/config.ts';
// TEMP — @numentech/ai-chatbot styles removed alongside the ChatWidget
// stub in AppShell.tsx (sibling-repo file link doesn't resolve in Docker).
// Restore this line and the ChatWidget import when the package ships.
import './index.css';
import { isSimulEnabled, startTourLazy } from './lib/simulRuntime';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

/**
 * Optional auto-start: `?simul=true&tour=<persona>` boots a tour
 * straight out of the URL — handy for stakeholder share-links and
 * playback recordings. The lazy import means the Simul runtime stays
 * out of the main chunk for everyone else; we only pay for it when the
 * gate is open AND a tour key is present.
 */
if (isSimulEnabled()) {
  const params = new URLSearchParams(window.location.search);
  const tourKey = params.get('tour');
  if (tourKey) {
    void import('./tours').then(({ TOUR_REGISTRY }) => {
      const entry = Object.values(TOUR_REGISTRY).find((e) => e.persona === tourKey);
      if (entry) void startTourLazy(entry.tour);
    });
  }
}
